<template>
  <div>
    <Return :goStaff="false" :id="record_id" />
    <div class="bodyControll">
      <div class="steps">
        <Step :step="2" />
      </div>
      <div class="remark">
        <img src="@/assets/img/ico_t.png" alt="" /><span class="text">
          首次登记，根据企业成立日期，登记近三年业绩信息；次年登记，只需登记上一年度业绩信息；<br />
          业绩信息以收费时间计算，例如：收费时间为：2021年3月10日，则该项目业绩属于2021年度。
        </span>
      </div>
      <div class="them" style="margin-top: 28px">
        <div class="line"></div>
        近{{ yearCount }}年业绩信息
      </div>
      <el-table :data="tableData" class="tableControll" empty-text="暂无数据">
        <el-table-column
          style="margin-left: 30px"
          type="index"
          label="序号"
          width="80px"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="year" label="年度" align="center">
        </el-table-column>
        <el-table-column align="center" label="登记状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0" class="organ status">
              未登记
            </span>
            <span v-else class="green status"> 已登记 </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="project_count"
          align="center"
          label="年度项目数量(个) "
        >
        </el-table-column>
        <el-table-column
          prop="project_income"
          align="center"
          label="年度工程造价营业收入(万)"
        >
        </el-table-column>
        <el-table-column prop="address" align="center" label="操作">
          <template slot-scope="scope">
            <!--            <el-link @click="goDetail(scope.row.id)" class="handle"-->
            <!--              >查看详情-->
            <!--            </el-link>-->
            <el-link class="handle">
              <a
                target="_blank"
                class="link"
                @click="goRecord(scope.$index, scope.row.year)"
              >进入登记</a
              ></el-link
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="btnControll">
        <!--        <div class="save" @click="saveBtn()">保存</div>-->
        <div class="go" @click="sub()">提交信息登记</div>
      </div>
      <!--      :before-close="handleClose"-->
      <el-dialog
        title="操作提示"
        :visible.sync="subDialogVisible"
        width="540px"
        :close-on-click-modal="false"
      >
        <div class="tip">
          <img src="@/assets/img/succ.png" alt="" />
          <span>信息提交成功！请耐心等待审核并在登记信息列表进行查看。</span>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="subDialogVisible = false"
          >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Return from "@/components/record/Return";
import Step from "@/components/record/Step";
import { canRegYear, submitExamine, isFinish } from "@/api/yj";

export default {
  name: "yjIndex",
  components: {
    Return,
    Step
  },
  data() {
    return {
      year: null,
      record_id: null, // 记录ID
      subDialogVisible: false,
      yearCount: "", //总共要填写几年
      yearArr: [], //获取的年份这个数组
      tableData: [] //大表 存放这些年多条的业绩信息
    };
  },
  async created() {
    if (this.$route.query.record_id) {
      this.record_id = this.$route.query.record_id;
    }
    if (this.$route.query.yearyear) {
      this.year = this.$route.query.record_id;
    }
    //获取可以填报的年份
    this.getYear();
  },
  methods: {
    //保存
    // saveBtn() {
    //   this.$message.success("保存成功！");
    // },
    async sub() {
      //提交前需要判断，如果都未填写，那么就不可以提交
      this.yearArr.forEach((item) => {
        if (item.status == 0) {
          this.$message.error("请填写完整后提交！");
          throw new Error("请填写完整后提交！");
        }
      });
      //提交前需要判断，是否有还未填写完的，弹提示语
      const res = await isFinish({ record_id: this.record_id });
      console.log(res);
      console.log(res.year);
      if (!res.finish) {
        this.$message.error(
          // "您在" + `${res.year}` + "年度有未完成的业绩，请完善"
          `您在${res.year}年度有未完成的业绩，请完善！`
        );
        return false;
      }

      this.subDialogVisible = true;
      submitExamine(this.record_id);
      setTimeout(() => {
        this.$router.push({
          name: "homeIndex"
        });
      }, 2000);
    },
    // 进入登记
    goRecord(index, year) {
      this.$router.push({
        name: "yjCreate",
        query: {
          index: index,
          year: year,
          record_id: this.record_id
        }
      });
    },
    async getYear() {
      const res = await canRegYear();
      // console.log(res, "获取可以填报的年份");
      this.yearArr = res;

      // 此处把数字转换为种文
      if (this.yearArr.length === 1) {
        this.yearCount = "一";
      } else if (this.yearArr.length === 2) {
        this.yearCount = "二";
      } else if (this.yearArr.length === 3) {
        this.yearCount = "三";
      } else {
        this.yearCount = "几";
      }
      // 新数组接收组装;
      this.tableData = this.yearArr;
    }
  }
};
</script>

<style lang="less" scoped>
.bodyControll {
  background: #ffffff;
  border-radius: 2px;
  padding: 20px 40px 40px 40px;
  margin-top: 10px;

  .steps {
    border-bottom: 1px solid #dddddd;
    padding: 0 149px 24px;
  }

  .remark {
    background: #eaf4ff;
    border: 1px solid #d2e7fb;
    border-radius: 2px;
    margin-top: 23px;
    display: flex;
    align-items: flex-start;
    padding: 5px 0 5px 12px;

    img {
      width: 13px;
      height: 13px;
      margin-top: 5px;
    }

    .text {
      font-size: 12px;
      color: #333333;
      line-height: 20px;
      margin-left: 10px;
    }
  }

  .them {
    display: flex;
    align-items: center;
    position: relative;
    font-size: 14px;
    font-weight: 700;
    color: #333333;
    padding-left: 15px;

    .line {
      width: 4px;
      height: 16px;
      background: #4379f6;
      left: 0px;
      position: absolute;
    }

    .des {
      font-size: 14px;
      color: #666666;
      margin-left: 20px;
      font-weight: 400;
    }
  }

  .tableControll {
    width: 100%;
    border: solid 1px rgb(235, 238, 245);
    border-bottom: unset;
    margin-top: 16px;
  }

  .green {
    background: #e8f8e9;
    color: #25a22d;
  }

  .organ {
    background: #f9f2e9;
    color: #f39020;
  }

  .status {
    font-size: 12px;
    padding: 2px;
  }

  /deep/ .el-table th {
    background: #f6f6f6 !important;
    color: #666;
    font-weight: normal;
  }

  /deep/ .el-table tr {
    color: #333 !important;
    font-size: 12px;
  }

  /deep/ .el-table__empty-text {
    line-height: unset;
  }

  .btnControll {
    display: flex;
    align-items: center;

    div {
      margin-top: 40px;
      width: 100px;
      height: 38px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    .save {
      background: #d7ddeb;
      color: #333;
    }

    .go {
      background: #f39020;
      color: #fff;
      //margin-left: 20px;
    }
  }

  .tip {
    display: flex;
    align-items: center;

    img {
      width: 22px;
      height: 22px;
    }

    span {
      margin-left: 7px;
      font-size: 14px;
      color: #262b36;
    }
  }

  /deep/ .el-dialog__header {
    border-bottom: 1px solid #dddddd;
  }

  /deep/ .el-dialog__footer {
    background: #f5f5f5;
    height: 70px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 30px;
  }

  .dialog-footer {
    /deep/ .el-button--primary {
      width: 100px;
      background: #f39020;
    }

    /deep/ .el-button {
      padding: unset;
      width: 100px;
      height: 32px;
      border-radius: unset;
    }
  }
}
</style>
